import { fun_GetAction } from "@/api";
export default {
  data() {
    return {
      // 默认选中tab
      activeName: "0",
      // tab数据
      tabList: [],
      // 登录类型
      loginType: sessionStorage.getItem("loginType"),
      // 组件路径
      rendertpl: null,
      // 传递参数
      params: {}
    }
  },
  // 模板编译完成
  mounted() {
    // 获取用户注册显示信息
    this.fun_UserRegisterPage();
  },
  // 自定义方法
  methods: {
    /**
     * 获取用户注册显示信息
     */
    fun_UserRegisterPage() {
      // 调用登录接口
      fun_GetAction("/userRegister/userRegisterPage?type=" + sessionStorage.getItem("loginType")).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断接口参数result
        if (result) {
          // 设置
          this.tabList = data;

          this.rendertpl = this.fun_Loadertpl(this.tabList[0].path);
        }
      });
    },
    /**
     * @description 切换tabs
     * @author
     */
    fun_HandleClick(tab, event) {
      // 获取下标
      const index = tab.name;
      // 切换标签页
      this.activeName = tab.name;
      // 如果是企业登记，且是招标人/投标人/招标代理
      if (tab.name === "0" && (this.loginType === "201904241041160002" || this.loginType === "201904241343420001" || this.loginType === "201904241346560059")) {
        // 默认展示企业登记详情
        this.rendertpl = this.fun_Loadertpl("corpRegistrationDetails");
      } else {
        // 跳转菜单
        this.rendertpl = this.fun_Loadertpl(this.tabList[index].path);
        // 详情返回的tab绑定值不为空
        if (this.params.activeName) {
          // 清空传递的对象参数
          this.fun_Details(this.tabList[index].path, {});
        }
      }
    },
    /**
     * 加载本地文件
     * @author 滕威
     */
    fun_Loadertpl(pathName) {
      // 如果是详情
      if (pathName.indexOf("Details") !== -1) {
        // 截取字符串
        const path = pathName.match(/(\S*)Details/)[1];
        // 切换详情
        return function (resolve) {
          require(["./" + path + "/details/index.vue"], resolve).default;
        };
        // 如果是网上CA资料申报
      } else if (pathName.indexOf("Declare") !== -1) {
        // 截取字符串
        const path = pathName.match(/(\S*)Declare/)[1];
        // 切换详情
        return function (resolve) {
          require(["." + path + "/declare/index.vue"], resolve).default;
        };
        // 如果是转入弹框
      } else if (pathName.indexOf("UnChoose") !== -1) {
        // 截取字符串
        const path = pathName.match(/(\S*)UnChoose/)[1];
        // 切换详情
        return function (resolve) {
          require(["." + path + "/unChoose/index.vue"], resolve).default;
        };
      }
      // 如果是自动转入弹框
      else if (pathName.indexOf("AutoChoose") !== -1) {
        // 截取字符串
        const path = pathName.match(/(\S*)AutoChoose/)[1];
        // 切换详情
        return function (resolve) {
          require(["." + path + "/autoChoose/index.vue"], resolve).default;
        };
      }
      // 如果是转入企业
      else if (pathName.indexOf("UnCorpChoose") !== -1) {
        // 截取字符串
        const path = pathName.match(/(\S*)UnCorpChoose/)[1];
        // 切换详情
        return function (resolve) {
          require(["." + path + "/unCorpChoose/index.vue"], resolve).default;
        };
      }
      else {
        // 一览
        return function (resolve) {
          require(["." + pathName + "/index.vue"], resolve).default;
        };
      }
    },
    /**
     * 跳转详情页面
     * @author 滕威
     */
    fun_Details(path, params) {
      // 获取页面类型
      this.params = params;
      // 加载本地文件
      this.rendertpl = this.fun_Loadertpl(path);
    },
    /**
     * 返回上一页
     * @author 滕威
     */
    fun_Back(e) {
      // 声明
      var path
      // 判断
      if (e) {
        // 遍历数据
        this.tabList.map((item, index) => {
          // 判断id
          if (item.id === e) {
            // 定位切换
            this.activeName = index + '';
            // 路径
            path = item.path;
          }
        })
      } else {
        // 路径
        path = this.tabList[this.activeName].path;
      }
      //加载本地文件
      this.rendertpl = this.fun_Loadertpl(path);
    }
  }
}